<template>
	<div>
		<button
			:class="[buttonClass, 'np-lookup-modal', 'np-whitespace-no-wrap']"
			type="button"
			@click="lookupClicked"
		>
			{{ lookupText }}
		</button>
		<Portal to="modals" :disabled="!portalExists('modals')">
			<NpModal
				:adaptive="true"
				height="auto"
				:name="`lookup-modal`"
				:max-width="400"
				:width="400"
				:scrollable="true"
				:classes="`np-lookup-modal v--modal`"
			>
				<div class="np-lookup-modal np-p-10 np-relative">
						<button
							class="np-lookup-modal__close_top np-absolute np-mr-2 np-mt-2 np-right-0 np-top-0 np-text-gray-600 hover:np-text-gray-700"
							type="button"
							@click="closeModal"
						>
							<FaIcon :icon="['fal', 'times-circle']" size="lg"/>
						</button>
					<LookupForm @close="$modal.hide('lookup-modal')"/>
				</div>
			</NpModal>
		</Portal>
	</div>
</template>

<script>
import LookupForm from '@/components/lookup/LookupForm.vue';
import portalMixin from '@/mixins/portalMixin';

export default {
	name: 'LookupModal',
	mixins: [portalMixin],
	components: {
		LookupForm,
	},

	props: {
		buttonClass: {
			type: String,
			default: 'np-button np-button--primary np-button--sm',
		},
		lookupText: {
			type: String,
			default: 'Lookup Reservation',
		},
	},

	data() {
		return {
			email: '',
		}
	},

	methods: {
		lookupClicked() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'reservationLookup',
				fromInfo: '',
			});
			this.$modal.show('lookup-modal');
		},

		closeModal() {
			this.$store.dispatch('googleEvents/genericButtonPressed', {
				buttonName: 'reservationLookupExit',
				fromInfo: '',
			});
			this.$modal.hide('lookup-modal');
		},
	},
};
</script>
